export default __webpack_public_path__ + "static/media/img-large.9b841c9a.png";